import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function LandingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen" style={{ backgroundColor: "#FAF8F5" }}>
      {/* Header */}
      <header className="shadow-sm" style={{ backgroundColor: "#FAF8F5" }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
          <div className="flex items-center">
            <img
              src="/PlexysLogo012526.png"
              alt="Plexys Logo"
              className="h-10"
            />
          </div>
          <div className="flex gap-4">
            <button
              onClick={() => navigate("/refer/login")}
              className="px-4 py-2 font-medium text-white"
              style={{ backgroundColor: "#30853A" }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#276e31")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#30853A")}
            >
              Log In
            </button>
            <button
              onClick={() => navigate("/refer/register")}
              className="px-6 py-2 text-white rounded-lg font-medium"
              style={{ backgroundColor: "#30853A" }}
              onMouseEnter={(e) => (e.target.style.backgroundColor = "#276e31")}
              onMouseLeave={(e) => (e.target.style.backgroundColor = "#30853A")}
            >
              Get Started
            </button>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 gap-12 items-center relative">
          <div className="text-left relative z-10">
            <div className="flex justify-center mb-6">
              <img
                src="/PlexysLogo012526.png"
                alt="Plexys Logo"
                className="h-40"
              />
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 text-center">
              Intelligent Referral Management
              <br />
              <span style={{ color: "#30853A" }}>& Market Analysis</span>
            </h2>
            <p className="text-xl text-gray-600 mb-8 text-center">
              Transform how you track referrals, analyze referral quality, and
              identify market opportunities. Built for specialists who want
              data-driven insights into their referral networks.
            </p>
            <div className="flex gap-4 justify-center">
              <button
                onClick={() => navigate("/refer/register")}
                className="px-8 py-4 text-white text-lg rounded-lg font-semibold shadow-lg"
                style={{ backgroundColor: "#30853A" }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#276e31")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#30853A")
                }
              >
                Start Free Trial
              </button>
              <button
                onClick={() => navigate("/refer/login")}
                className="px-8 py-4 text-lg rounded-lg font-semibold border-2"
                style={{ color: "#30853A", borderColor: "#30853A", backgroundColor: "#FFFFFF" }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#f0fdf4")
                }
                onMouseLeave={(e) => (e.target.style.backgroundColor = "#FFFFFF")}
              >
                Sign In
              </button>
            </div>
          </div>
          <div className="relative flex justify-end items-center overflow-hidden">
            <div
              className="absolute inset-0"
              style={{
                background: "linear-gradient(to right, rgba(250, 248, 245, 1) 0%, rgba(250, 248, 245, 0) 30%, transparent 100%)"
              }}
            ></div>
            <img
              src="/physHero.png"
              alt="Healthcare Specialists"
              className="w-full h-full object-cover"
              style={{ minHeight: "600px", maxHeight: "700px" }}
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Everything You Need to Optimize Referrals
        </h3>
        <div className="grid md:grid-cols-3 gap-8">
          {/* Feature 1 */}
          <div className="p-8 rounded-lg shadow-md" style={{ backgroundColor: "#FFFFFF" }}>
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
              style={{ backgroundColor: "rgba(48, 133, 58, 0.1)" }}
            >
              <svg
                className="w-6 h-6"
                style={{ color: "#30853A" }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-3">
              Referral Quality Tracking
            </h4>
            <p className="text-gray-600">
              Track and analyze the quality of each referral with our
              proprietary Referral Value scoring system. Identify your most
              valuable referral sources instantly.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="p-8 rounded-lg shadow-md" style={{ backgroundColor: "#FFFFFF" }}>
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
              style={{ backgroundColor: "rgba(48, 133, 58, 0.1)" }}
            >
              <svg
                className="w-6 h-6"
                style={{ color: "#30853A" }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-3">
              Geographic Market Analysis
            </h4>
            <p className="text-gray-600">
              Visualize referral patterns and identify untapped markets with
              interactive heatmaps. Discover high-opportunity ZIP codes in your
              region.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="p-8 rounded-lg shadow-md" style={{ backgroundColor: "#FFFFFF" }}>
            <div
              className="w-12 h-12 rounded-lg flex items-center justify-center mb-4"
              style={{ backgroundColor: "rgba(48, 133, 58, 0.1)" }}
            >
              <svg
                className="w-6 h-6"
                style={{ color: "#30853A" }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
                />
              </svg>
            </div>
            <h4 className="text-xl font-semibold text-gray-900 mb-3">
              Provider Network Intelligence
            </h4>
            <p className="text-gray-600">
              Access real-time provider data integrated with the NPI database.
              Build strategic relationships with high-quality referral sources.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16" style={{ backgroundColor: "#30853A" }}>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-3xl font-bold text-white mb-4">
            Ready to Transform Your Referral Strategy?
          </h3>
          <p className="text-xl text-green-100 mb-8">
            Join healthcare providers who are making smarter, data-driven
            decisions about their referral networks.
          </p>
          <button
            onClick={() => navigate("/refer/register")}
            className="px-8 py-4 bg-white text-lg rounded-lg hover:bg-gray-100 font-semibold shadow-lg"
            style={{ color: "#30853A" }}
          >
            Get Started Today
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-300 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            <div>
              <h5 className="text-white font-semibold text-lg mb-4">Plexys</h5>
              <p className="text-sm text-gray-400">
                Intelligent referral management and market analysis for
                healthcare providers.
              </p>
            </div>
            <div>
              <h6 className="text-white font-semibold mb-4">Product</h6>
              <ul className="space-y-2 text-sm">
                <li>
                  <span
                    onClick={() => navigate("/refer/login")}
                    className="cursor-pointer hover:text-white"
                  >
                    Dashboard
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => navigate("/refer/login")}
                    className="cursor-pointer hover:text-white"
                  >
                    Market Radar
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => navigate("/refer/login")}
                    className="cursor-pointer hover:text-white"
                  >
                    Analytics
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-white font-semibold mb-4">Company</h6>
              <ul className="space-y-2 text-sm">
                <li>
                  <span
                    onClick={() => navigate("/refer/register")}
                    className="cursor-pointer hover:text-white"
                  >
                    Get Started
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => navigate("/refer/login")}
                    className="cursor-pointer hover:text-white"
                  >
                    Sign In
                  </span>
                </li>
              </ul>
            </div>
            <div>
              <h6 className="text-white font-semibold mb-4">Legal</h6>
              <ul className="space-y-2 text-sm">
                <li>
                  <span
                    onClick={() => navigate("/privacy-policy")}
                    className="cursor-pointer hover:text-white"
                  >
                    Privacy Policy
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => navigate("/terms-of-service")}
                    className="cursor-pointer hover:text-white"
                  >
                    Terms of Service
                  </span>
                </li>
              </ul>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 text-center text-sm text-gray-400">
            <p>
              &copy; {new Date().getFullYear()} Plexys Limited. All rights
              reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
